"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const native_1 = require("@react-navigation/native");
const react_i18next_1 = require("react-i18next");
const flightHandlers_1 = require("../../handlers/flightHandlers");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const NavigationWrapperWeb_1 = __importDefault(require("../common/NavigationWrapperWeb"));
const GoBack_1 = __importDefault(require("../common/GoBack"));
const userHandlers_1 = require("../../handlers/userHandlers");
const PaymentOverviewWeb_1 = __importDefault(require("../common/PaymentOverviewWeb"));
const ButtonWeb_1 = __importDefault(require("../common/ButtonWeb"));
const myFlightsHelper_1 = require("../../services/myFlightsHelper");
const PaymentOfferWeb = ({ route: { params: { id, passengers } } }) => {
    const navigation = (0, native_1.useNavigation)();
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'payment' });
    const [prices, setPrices] = react_1.default.useState({
        price: 0.0,
        transaction_fee: 0.0,
        transaction_fee_rate: 0.0,
        transaction_fee_min: 0
    });
    const [buttonLocked, setButtonLocked] = react_1.default.useState(false);
    const flightOfferData = (0, react_redux_1.useSelector)(selectors_1.getFlightOffer);
    const userDetails = (0, react_redux_1.useSelector)(selectors_1.getUser);
    (0, react_1.useEffect)(() => {
        !flightOfferData && (0, flightHandlers_1.getFlightOfferHandler)(id);
        flightOfferData && (0, flightHandlers_1.getFlightOfferTotalPriceHandler)(flightOfferData.id, passengers, setPrices);
        !userDetails && (0, userHandlers_1.getUserDetailsHandler)();
    }, [flightOfferData]);
    return ((0, jsx_runtime_1.jsxs)(NavigationWrapperWeb_1.default, { children: [(0, jsx_runtime_1.jsx)(GoBack_1.default, { onBack: () => {
                    navigation.goBack();
                }, title: "" }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "title", children: t('payment') }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "font-26-600", children: t('order_summary') }) }), flightOfferData && userDetails &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PaymentOverviewWeb_1.default, { flightData: (0, myFlightsHelper_1.prepareFlightDetailsDataFromFlightOffer)(flightOfferData, userDetails), passengers: passengers, prices: prices }), (0, jsx_runtime_1.jsxs)(ButtonWeb_1.default, { type: "Blue", isDisabled: buttonLocked, onClick: () => {
                                (0, flightHandlers_1.startFlightOfferPaymentHandler)(flightOfferData.id, passengers);
                                setButtonLocked(true);
                            }, fullWidth: true, style: { marginTop: 10 }, children: [t('pay'), " ", prices.transaction_fee, " z\u0142"] })] })] }));
};
exports.default = PaymentOfferWeb;
